import { useApi } from "../../../swr/useApi";
import { productScreenSizesService } from "../../api_client";
import type { ProductScreenSizeDto } from "../../../api";

export function useProductScreenSizes() {
    return useApi<ProductScreenSizeDto[]>("product-screen-sizes", async () => {
        return await productScreenSizesService.getProductScreenSizes();
    });
}

